import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';

const KINDS = ['products', 'prices', 'stocks'] as const;

export function SyncPage() {
  const qc = useQueryClient();
  const health = useQuery({ queryKey: ['health'], queryFn: api.health, refetchInterval: 10_000 });
  const runs = useQuery({ queryKey: ['sync-runs'], queryFn: () => api.syncRuns(), refetchInterval: 5_000 });
  const trigger = useMutation({
    mutationFn: (kind: typeof KINDS[number]) => api.triggerSync(kind),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['sync-runs'] }),
  });

  return (
    <>
      <div className="page-header">
        <h2>Синхронизация</h2>
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>Состояние</h3>
        {health.data ? (
          <>
            <div>База данных: {health.data.db}</div>
            <div>
              Ozon API:{' '}
              {health.data.ozon.configured
                ? `✅ настроен (источник: ${health.data.ozon.source === 'db' ? 'настройки в БД' : '.env файл'})`
                : '❌ ключи не заданы — открой страницу «Настройки»'}
            </div>
            <div>Ozon Premium: {health.data.ozon.premium ? 'Да' : 'Нет'}</div>
          </>
        ) : 'Загрузка…'}
      </div>

      <div className="card" style={{ marginBottom: 16 }}>
        <h3 style={{ marginTop: 0 }}>Ручной запуск</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          {KINDS.map((kind) => (
            <button key={kind} className="btn" onClick={() => trigger.mutate(kind)} disabled={trigger.isPending}>
              {kind}
            </button>
          ))}
        </div>
        {trigger.isPending && <div className="muted" style={{ marginTop: 8 }}>Отправка в очередь…</div>}
        {trigger.data && (
          <div style={{ marginTop: 8, color: 'var(--green)', fontSize: 13 }}>
            ✓ Задача поставлена в очередь (jobId: {trigger.data.jobId ?? '—'}). Прогресс смотри в таблице ниже.
          </div>
        )}
        {trigger.error && <div style={{ color: 'var(--red)', marginTop: 8, fontSize: 13 }}>Ошибка: {(trigger.error as Error).message}</div>}
      </div>

      <h3>История запусков</h3>
      <table className="products">
        <thead>
          <tr>
            <th>Тип</th>
            <th>Статус</th>
            <th>Старт</th>
            <th>Финиш</th>
            <th className="num">Элементов</th>
            <th>Ошибка</th>
          </tr>
        </thead>
        <tbody>
          {runs.data?.items.length === 0 && (
            <tr><td colSpan={6} className="muted" style={{ textAlign: 'center', padding: 24 }}>
              Запусков ещё не было.
            </td></tr>
          )}
          {runs.data?.items.map((r) => (
            <tr key={r.id}>
              <td>{r.kind}</td>
              <td>{r.status}</td>
              <td className="muted">{new Date(r.startedAt).toLocaleString('ru-RU')}</td>
              <td className="muted">{r.finishedAt ? new Date(r.finishedAt).toLocaleString('ru-RU') : '—'}</td>
              <td className="num">{r.itemsProcessed}</td>
              <td className="muted" style={{ color: r.errorText ? 'var(--red)' : undefined }}>{r.errorText ?? '—'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
